import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import DayPickerRangeController from "@components/react-dates/DayPickerRangeController";
import { register, unregister } from "@shared/core/globalClick";
import { isInclusivelyAfterDay } from "@shared/core/date";
import moment from "moment";
import SvgIcon from "@components/icon/svg";
import ActionGroup from "./action-group";

const Wrapper = "DateRangeWrapper";

// const weekDayArr = ['一', '二', '三', '四', '五', '六', '日']

class DateRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
      focusedInput: "startDate",
      ...this.getStateByProps(props),
    };
  }

  componentDidMount() {
    register(this, Wrapper);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateByProps(nextProps));
  }

  componentWillUnmount() {
    unregister(this, Wrapper);
  }

  onGlobalClick() {
    if (this.state.display && !this.state.forcing) {
      this.setState({
        display: false,
      });
    } else {
      this.setState({ forcing: false });
    }
  }

  getStateByProps(props) {
    const { value, display } = props;
    let startDate;
    let endDate;
    if (value.dateBegin) {
      startDate = moment(value.dateBegin, "YYYYMMDD");
    }
    if (value.dateEnd) {
      endDate = moment(value.dateEnd, "YYYYMMDD");
    }
    return {
      display,
      forcing: display,
      startDate,
      endDate,
    };
  }

  getText() {
    const { value, defaultText, format, hyphen } = this.props;
    let FM;
    if (typeof format === "string") FM = [format];
    else FM = format;
    const { dateBegin, dateEnd } = value;
    if (dateBegin && dateEnd) {
      const mBegin = moment(dateBegin, "YYYYMMDD");
      const mEnd = moment(dateEnd, "YYYYMMDD");
      return [
        <span key="date-range" className="date">
          {mBegin.format(FM[0])}
          {hyphen}
          {mEnd.format(FM[1] || FM[0])}
        </span>,
        <span key="nights" className="days">
          {mEnd.diff(mBegin, "days")}晚
        </span>,
      ];
    }
    return defaultText;
  }

  render() {
    moment.locale("zh-cn");
    const { defaultText } = this.props;
    const text = this.getText();
    return (
      <div className="search-menu search-menu__date-range" ref={Wrapper}>
        <button
          type="button"
          className={cx("search-menu__label search-menu__label--date-range", {
            "search-menu__label--highlight": text !== defaultText,
            "search-menu__label--active": this.state.display,
          })}
          onClick={() => {
            const display = !this.state.display;
            this.setState({
              display,
              focusedInput: display ? "startDate" : null,
            });
          }}
        >
          <SvgIcon symbol={require("@shared/icons/calendar.svg")} />
          {text}
          <SvgIcon symbol={require("@shared/icons/expand-thin.svg")} size="xs" />
        </button>
        {!this.state.display || (
          <div className="search-menu__content">
            <DayPickerRangeController
              startDate={this.state.startDate} // momentPropTypes.momentObj or null,
              endDate={this.state.endDate} // momentPropTypes.momentObj or null,
              onDatesChange={({ startDate, endDate }) => {
                this.setState({ startDate, endDate });
              }} // PropTypes.func.isRequired,
              focusedInput={this.state.focusedInput || "startDate"} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
              hideKeyboardShortcutsPanel={true}
              firstDayOfWeek={0}
              monthFormat="YYYY年MM月"
              numberOfMonths={2}
              isOutsideRange={day => !isInclusivelyAfterDay(day, moment())}
            />
            <ActionGroup
              onConfirm={() => {
                this.setState({
                  display: false,
                });
                let newValue;
                if (this.state.startDate && this.state.endDate) {
                  newValue = {
                    dateBegin: this.state.startDate.format("YYYYMMDD"),
                    dateEnd: this.state.endDate.format("YYYYMMDD"),
                  };
                } else {
                  newValue = {
                    dateBegin: null,
                    dateEnd: null,
                  };
                }
                this.props.onChange(newValue);
              }}
              onClear={() => {
                this.setState({
                  startDate: null,
                  endDate: null,
                });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

DateRange.propTypes = {
  value: PropTypes.shape({
    dateBegin: PropTypes.string,
    dateEnd: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  defaultText: PropTypes.string,
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hyphen: PropTypes.string,
};

DateRange.defaultProps = {
  value: {},
  defaultText: "入住-退房日期",
  format: "MM/DD",
  hyphen: "-",
};

export default DateRange;

require("./date-range.less");
require("./index.less");